<div class="container-modal">
  <div class="title">
    <span>Capas activas</span>
    <span (click)="setShowSelected()">X</span>
  </div>
  <div class="p-3">Vista principal</div>
  <ion-content>
    <div class="list-a">
      <div class="p-3" *ngIf="layers.length <=0 ">No hay capas activas para esta vista</div>
      <div class="list-content">
        <ion-list lines="full" *ngFor="let item of layers">
          <ion-item>
            <ion-label>{{item.name}}</ion-label>
          </ion-item>
        </ion-list>
      </div>      
    </div>       
  </ion-content>
  <div class="p-3">Vista comparativa</div>
  <ion-content>
    <div class="list-a">      
      <div class="p-3" *ngIf="layersCompare.length <=0 ">No hay capas activas para esta vista</div>
      <div class="list-content">
        <ion-list lines="full" *ngFor="let item of layersCompare">
          <ion-item>
            <ion-label>{{item.name}}</ion-label>
          </ion-item>
        </ion-list>
      </div>      
    </div> 
  </ion-content>
</div>